module.exports = __webpack_public_path__ + "img/news@2x.8161d153.png";